module.exports = __webpack_public_path__ + "img/球2@2x.5579088e.png";